export const PARENT_URL = {
  BASE_SERVER: process.env.REACT_APP_BASE_SERVER,
  DASHBOARD: process.env.REACT_APP_DASHBOARD,
  RESOURCES: process.env.REACT_APP_RESOURCES,
  PROJECTS: process.env.REACT_APP_PROJECTS,
  FEEDBACKS: process.env.REACT_APP_FEEDBACKS,
  INVITATIONS: process.env.REACT_APP_INVITATIONS,
  UPDATES: process.env.REACT_APP_UPDATES,
  VACATIONS: process.env.REACT_APP_VACATIONS,
  APP_NOTIFICATIONS: process.env.REACT_APP_NOTIFICATIONS,
  META_DATA: process.env.REACT_APP_META_DATA,
  TEAM_LEAD_BASE: process.env.REACT_APP_TEAM_LEAD_BASE,
  TEAM_BUILDER_BASE: process.env.REACT_APP_TEAM_BUILDER_BASE,
  TIMELINE_BASE: process.env.REACT_APP_TIMELINE_BASE,
};
